var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.52 53.048 1.415 1.414-4.101 4.101-1.415-1.414 4.102-4.101ZM30 11.63c10.146 0 18.37 8.224 18.37 18.37 0 10.145-8.224 18.37-18.37 18.37-10.145 0-18.37-8.225-18.37-18.37 0-10.146 8.225-18.37 18.37-18.37ZM5.424 33.312l1.414 1.415-4.101 4.1-1.414-1.413 4.101-4.102ZM55.52 29.09a1.69 1.69 0 1 1 0 3.38 1.69 1.69 0 0 1 0-3.38ZM28.35 1.882l4.1 4.101-1.413 1.414-4.102-4.101 1.415-1.414Z",
    fill: "#312E81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27.79 38.96-7.42-7.42 2.12-2.13 5.3 5.31 10.98-10.99 2.12 2.13-13.1 13.1Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m54.574 39.187 4.101 4.101-1.414 1.414-4.101-4.101 1.414-1.414ZM56.27 10.71l-1.33 4.96-3.63-3.63 4.96-1.33ZM10.3 6.88l4.96 1.33-3.63 3.63-1.33-4.96Z",
    fill: "#28BF9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1 51.19a1.69 1.69 0 1 1 0 3.38 1.69 1.69 0 0 1 0-3.38ZM6.8 45.63l4.96 1.32-3.63 3.64-1.33-4.96ZM7 16.31a1.69 1.69 0 1 1 0 3.38 1.69 1.69 0 0 1 0-3.38ZM41.25 1.99a1.69 1.69 0 1 1 0 3.38 1.69 1.69 0 0 1 0-3.38Z",
    fill: "#FFD527"
  })));
};
export default SvgSuccess;